// @ts-strict-ignore
import { ClassValue } from 'classnames/types'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { PerPageSelect } from '../../packages/blueprint-components/src/PerPageSelect'
import { number } from '../../util/formatters'
import { Pagination } from './../../packages/blueprint-components/src/Pagination'
import { TableStore } from './table_store'

interface TableBottomSectionProps {
    paginationClassname?: ClassValue
    stickyFooterSection?: object
    /** Whether to show the per page select dropdown */
    showPerPage?: boolean
    perPageLabel: string
    isWidget?: boolean
    store: TableStore<any>
}

export const TableBottomSection2 = observer(
    ({
        paginationClassname,
        stickyFooterSection,
        showPerPage,
        perPageLabel,
        isWidget = false,
        store,
    }: TableBottomSectionProps) => {
        if (!store.pagination) {
            return null
        }

        const shouldShowPerPage =
            showPerPage &&
            store.pagination.current &&
            store.pagination.total &&
            store.pagination.total > 0

        return (
            <div
                id={isWidget ? 'table-bottom-section-widget' : 'table-bottom-section'}
                className={
                    'd-flex align-items-center justify-content-between mt-4 ' + paginationClassname
                }
                style={{ ...stickyFooterSection }}
            >
                <div
                    id="bottom-left-section"
                    className={store.loading ? 'bp4-skeleton text-xs' : 'text-xs'}
                >
                    Displaying {store.pagination.from ?? 0} - {store.pagination.to ?? 0} of{' '}
                    {number(store.pagination.total) ?? 0}
                </div>
                <div id="bottom-right-section">
                    {!!shouldShowPerPage && (
                        <PerPageSelect
                            value={store.params.perPage}
                            onChange={(e) => {
                                store.setPerPage(parseInt(e.target.value))
                            }}
                            label={perPageLabel}
                            minimal
                            className="float-left mr-4"
                        />
                    )}
                    <Pagination
                        className="float-left"
                        minimal
                        loading={store.loading}
                        current={store.pagination.current}
                        total={store.pagination.last_page}
                        onClick={(page) => {
                            console.log('page', page)
                            store.setPage(page)
                        }}
                    />
                </div>
            </div>
        )
    },
)
